import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
 * Gibt eine Konfession zurück.
 */
export function getDenomination(id: number): JQueryPromise<modelsGet.IDenomination>
{
    var endpoint = new URI("api/denominations");
    endpoint.segment(id.toString());

    return api.get<modelsGet.IDenomination>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Konfessionen zurück.
 */
export function getDenominations(): JQueryPromise<modelsGet.IDenomination[]>
{
    var endpoint = new URI("api/denominations");

    return api.get<modelsGet.IDenomination[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(denomination: modelsPost.IDenomination): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/denominations/create",
        data: JSON.stringify(denomination)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, denomination: modelsPost.IDenomination): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/denominations/edit/${id}`,
        data: JSON.stringify(denomination)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/denominations/delete/${id}`
    });
}